import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Heading from "@tiptap/extension-heading";
import BulletList from "@tiptap/extension-bullet-list";
import OrderedList from "@tiptap/extension-ordered-list";
import Blockquote from "@tiptap/extension-blockquote";
import CodeBlock from "@tiptap/extension-code-block";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import HardBreak from "@tiptap/extension-hard-break";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import TextStyle from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import Subscript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import Underline from "@tiptap/extension-underline";
import Strike from "@tiptap/extension-strike";
import Italic from "@tiptap/extension-italic";
import Bold from "@tiptap/extension-bold";
import Code from "@tiptap/extension-code";
import Paragraph from "@tiptap/extension-paragraph";
import Document from "@tiptap/extension-document";
import Text from "@tiptap/extension-text";
import FontFamily from "@tiptap/extension-font-family";
import FontSize from "@tiptap/extension-font-size";
// import Placeholder from "@tiptap/extension-placeholder";
import Toolbar from "./toolbar/Toolbar";
import "../../../tiptapStyle.css";
import { classNames } from "../../../helpers/classNames";

const EditorComponent = ({
  fontFamilies,
  value = "",
  onChange = () => {},
  height = 500,
  label,
  required,
  placeholder,
}) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: false,
        bulletList: false,
        orderedList: false,
        blockquote: false,
        codeBlock: false,
        horizontalRule: false,
        hardBreak: false,
        link: false,
        image: false,
        table: false,
        taskList: false,
        highlight: false,
        textAlign: false,
        textStyle: false,
        color: false,
        subscript: false,
        superscript: false,
        underline: false,
        strike: false,
        italic: false,
        bold: false,
        code: false,
        paragraph: false,
        document: false,
        text: false,
      }),
      Document,
      Paragraph,
      Text,
      Bold,
      Italic,
      Strike,
      Code,
      Underline,
      Subscript,
      Superscript,
      Highlight.configure({ multicolor: true }),
      TextAlign.configure({ types: ["heading", "paragraph"] }),
      TextStyle,
      Color,
      FontFamily,
      FontSize,
      Heading.configure({ levels: [1, 2, 3, 4, 5, 6] }),
      BulletList,
      OrderedList,
      Blockquote,
      CodeBlock,
      HorizontalRule,
      HardBreak,
      Link.configure({ openOnClick: false, autolink: true }),
      Image.configure({ inline: true, allowBase64: true }),
      Table.configure({ resizable: true }),
      TableCell,
      TableHeader,
      TableRow,
      TaskList,
      TaskItem.configure({ nested: true }),
    ],
    content: value,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      onChange(html);
    },
    editorProps: {
      attributes: {
        placeholder,
        class: "tiptap",
      },
    },
  });

  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value || "");
    }
  }, [value]);



  return (
    <div className="relative space-y-1">
      {label && (
        <div
          className={classNames(
            "text-xs font-medium text-text-disabled flex items-center gap-1"
            // labelClasses
          )}
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-14 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk" />
            </span>
          )}
        </div>
      )}

      <div className="border p-4 rounded-lg bg-white divide-y">
        <Toolbar editor={editor} fontFamilies={fontFamilies} />
        <div
          {...(height && { style: { minHeight: height, maxHeight: height } })}
          className={classNames(
            "px-5 pt-5 overflow-y-auto [&>div>.tiptap]:!rounded-none [&>div>.tiptap]:!bg-transparent [&>div>.tiptap]:!border-0",
            !height ? "min-h-40 max-h-60" : ""
          )}
          onClick={() => {
            if (editor) editor.commands.focus();
          }}
        >
          <EditorContent editor={editor} />
        </div>
      </div>
    </div>
  );
};

export default EditorComponent;

